export const REACT_NATIVE_STORE = 'CONNEXT_STORE'
export const DEFAULT_STORE_PREFIX = 'INDRA_CLIENT_CF_CORE'
export const DEFAULT_STORE_SEPARATOR = '/'
export const PATH_CHANNEL = 'channel'
export const PATH_PROPOSED_APP_INSTANCE_ID =
  'appInstanceIdToProposedAppInstance'
